import React, { Component } from "react";

const PortfolioListContent = [
  {
    image: "pro1",
    category: "#school_app_project",
    title:
      "Connecting Schools, Students, Teachers & Parents with each other, DiGiTALLY!",
  },
  // {
  //     image: 'image-2',
  //     category: 'Development',
  //     title: 'Getting tickets to the big show'
  // },
  // {
  //     image: 'image-3',
  //     category: 'Development',
  //     title: 'Getting tickets to the big show'
  // },
  // {
  //     image: 'image-4',
  //     category: 'Development',
  //     title: 'Getting tickets to the big show'
  // },
  // {
  //     image: 'image-3',
  //     category: 'Development',
  //     title: 'Getting tickets to the big show'
  // },
  // {
  //     image: 'image-4',
  //     category: 'Development',
  //     title: 'Getting tickets to the big show'
  // }
];

class ProjectList extends Component {
  render() {
    const { column, styevariation } = this.props;
    const list = PortfolioListContent.slice(0, this.props.item);
    return (
      <React.Fragment>
        {list.map((value, index) => (
          <div className={`${column}`} key={index}>
            <div
              className={`portfolio ${styevariation} center-block`}
              style={{ background: "#101010", borderRadius: "15px" }}
            >
              <div className="thumbnail-inner">
                {/* <div className={`thumbnail ${value.image}`}></div> */}
                <div className={`bg-blr-image ${value.image}`}></div>
              </div>
              <div className="content">
                <div className="inner">
                  <p>{value.category}</p>
                  <h4>
                    <a href="/portfolio-details">{value.title}</a>
                  </h4>
                  <div className="portfolio-button">
                    <a
                      className="rn-btn"
                      href="https://www.canva.com/design/DAEf1mVbBhU/GdXxle32hWECdRY7wqYDbg/view?utm_content=DAEf1mVbBhU&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EXPLORE MORE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}
export default ProjectList;
